import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import ButtonStyles from '../../../styles/button';
import TypographyStyles from '../../../styles/typography';
import LayoutStyles from '../../../styles/layout';
import SpacingStyles from '../../../styles/helpers/spacing';
import Button from '@material-ui/core/Button';
import combineStyles from '../../../utils/combineStyles';
import * as ShipmentUtils from '../../../utils/Shipment';
import ShipmentEditBillingInformationModal from '../../shipment/Modals/EditBillingInformation';
import FormItemContainer from '../../Global/Containers/FormItemContainer';
import _get from 'lodash/get';
import _isFunction from 'lodash/isFunction';
import { BILL_TO, SHIPMENT_DIRECTION } from '../../../constants/constants';

const BillingInfoStyles = theme => ({
  lastAddressRow: {
    marginBottom: theme.spacing.unit * 2.98
  },
  editButton: {
    paddingRight: 0,
    height: '28px'
  },
  buttonRoot: {
    '&:hover': {
      //you want this to be the same as the backgroundColor above
      backgroundColor: '#fff'
    }
  }
});

export class BillingInfo extends PureComponent {
  state = {
    modalOpen: false,
    isBillToInfoEmpty: false,
    billToLabels: {}
  };
  static propTypes = {
    billToInfo: PropTypes.object.isRequired,
    onUpdate: PropTypes.func.isRequired,
    locations: PropTypes.array.isRequired,
    contacts: PropTypes.array.isRequired,
    isNewShipment: PropTypes.bool.isRequired,
    editable: PropTypes.bool.isRequired,
    setFieldValue: PropTypes.func,
    shipmentDirection: PropTypes.string,
    defaultBillingTerms: PropTypes.object
  };
  handleOpenEditBillingInfoModal = () => {
    this.setState({ modalOpen: true });
  };
  _handleCloseEditBillingInfoModal = () => {
    this.setState({ modalOpen: false });
  };
  _handleUpdateBillingInfo = billingInfo => {
    const { onUpdate, setFieldValue } = this.props;
    if (_isFunction(setFieldValue)) {
      onUpdate(setFieldValue, billingInfo);
    } else {
      onUpdate(billingInfo);
    }
    this._handleCloseEditBillingInfoModal();
  };
  componentDidMount() {
    const { t } = this.props;
    this._checkIfEmpty();
    const billToLabels = {
      [BILL_TO.SHIPPER]: t('Shipper'),
      [BILL_TO.CONSIGNEE]: t('Consignee')
    };
    this.setState({ billToLabels });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.billToInfo.billTo !== this.props.billToInfo.billTo) {
      this._checkIfEmpty();
    }
    if (
      this.props.shipmentDirection &&
      prevProps.shipmentDirection !== this.props.shipmentDirection
    ) {
      const billInfo = { ...this.props.billToInfo };
      const { defaultBillingTerms } = this.props;
      let billTo = BILL_TO.SHIPPER;
      switch (this.props.shipmentDirection) {
        case SHIPMENT_DIRECTION.INBOUND:
          billTo = BILL_TO.CONSIGNEE;
          break;
        case SHIPMENT_DIRECTION.DROP:
          billTo = BILL_TO.THIRD_PARTY;
          billInfo.companyName = defaultBillingTerms.companyName;
          billInfo.billToAddress = defaultBillingTerms.addressInfo;
          billInfo.billToContactInfo = defaultBillingTerms.contactInfo;
          break;
        default:
          //shipper
          break;
      }
      billInfo.billTo = billTo;
      this._handleUpdateBillingInfo(billInfo);
    }
  }
  _checkIfEmpty = () => {
    const {
      billToInfo: { billTo }
    } = this.props;
    const isBillToInfoEmpty = !billTo;
    this.setState({ isBillToInfoEmpty });
  };
  render() {
    const {
      t,
      classes,
      contacts,
      locations,
      billToInfo,
      editable
    } = this.props;
    const { isBillToInfoEmpty, billToLabels } = this.state;
    const editButton =
      isBillToInfoEmpty || !editable ? (
        <div />
      ) : (
        <Button
          className={classnames(classes.button, classes.editButton)}
          onClick={this.handleOpenEditBillingInfoModal}
          color={'primary'}
          variant={'text'}
          disableRipple={true}
          classes={{
            label: classes.buttonLabel,
            root: classes.buttonRoot
          }}
        >
          {t('Edit')}
        </Button>
      );
    return (
      <FormItemContainer title={t('Bill to')} secondaryAction={editButton}>
        <div>
          {isBillToInfoEmpty && editable ? (
            <Button
              onClick={this.handleOpenEditBillingInfoModal}
              variant="outlined"
              className={classnames(
                classes.outlinedButton,
                classes.noMarginBottom
              )}
              color={'primary'}
              classes={{ label: classes.buttonLabel }}
            >
              {t('Add Billing Info')}
            </Button>
          ) : (
            <div>
              <h4 className={classes.subtitle3}>{t('Bill to')}</h4>
              {billToInfo.billTo === BILL_TO.THIRD_PARTY ? (
                <div>
                  <p className={classes.body2}>
                    {`${_get(billToInfo, 'companyName')}`}
                  </p>
                  <p className={classes.body2}>
                    {_get(billToInfo, 'billToAddress.address1')}
                  </p>
                  <p className={classes.body2}>
                    {_get(billToInfo, 'billToAddress.address2')}
                  </p>
                  <p
                    className={classnames(
                      classes.body2,
                      classes.lastAddressRow
                    )}
                  >
                    {ShipmentUtils.formatAddress(
                      _get(billToInfo, 'billToAddress')
                    )}
                  </p>
                  <p className={classes.body2}>
                    {_get(billToInfo, 'billToContactInfo.email')}
                  </p>
                  <p className={classes.body2}>
                    {_get(billToInfo, 'billToContactInfo.phone')}
                  </p>
                </div>
              ) : (
                <div className={classes.body2}>
                  {billToLabels[billToInfo.billTo]}
                </div>
              )}
            </div>
          )}
          <ShipmentEditBillingInformationModal
            open={this.state.modalOpen}
            onClose={this._handleCloseEditBillingInfoModal}
            onSave={this._handleUpdateBillingInfo}
            locations={locations}
            contacts={contacts}
            billToInfo={billToInfo}
          />
        </div>
      </FormItemContainer>
    );
  }
}
const translatedBillingInfo = withNamespaces()(BillingInfo);
export default withStyles(
  combineStyles(
    LayoutStyles,
    SpacingStyles,
    TypographyStyles,
    ButtonStyles,
    BillingInfoStyles
  )
)(translatedBillingInfo);
